import {
  getAllOrganisationsPaginated,
  usePaginatedApi,
  type PaginatedResponse,
  type PagedOrganisationResponse,
} from 'api';
import { STALE_TIME_MS, DefaultPageParam } from 'api/search';
import { QUERY_KEY_ROOTS } from '../../variables/constants';

type PaginatedOrganisationsOptions = {
  searchTerm?: string;
  enabled?: boolean;
};

export const useGetPaginatedOrganisations = ({
  searchTerm,
  enabled = true,
}: PaginatedOrganisationsOptions = {}) =>
  usePaginatedApi<
    PaginatedResponse<PagedOrganisationResponse>,
    PagedOrganisationResponse,
    DefaultPageParam
  >({
    enabled,
    fetchPage: getAllOrganisationsPaginated,
    queryKey: [QUERY_KEY_ROOTS.ORGANISATIONS_DATA],
    queryParams: searchTerm ? { searchTerm } : undefined,
    getItemsFromPage: (p) => p.response ?? [],
    initialPageParam: undefined,
    staleTime: STALE_TIME_MS,
  });
